module.exports = __webpack_public_path__ + "images/volleyball1-351834b3520437a57e3cfb490b3f781b.jpg";